import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.ganpatiwallpaper';

const WALLPAPERS_DATA = [
  {
    id: 1,
    title: 'Lalbaugcha Raja Divine Aura',
    category: 'Lalbaugcha Raja',
    resolution: '4K Ultra HD',
    author: 'Gaurav Kambli',
    url: 'https://res.cloudinary.com/vcwqbraw/image/upload/v1785955640/Gaurav_Kambli_0045_bqo0mo.jpg',
    downloads: '18.4k',
    likes: '4.9k',
    featured: true
  },
  {
    id: 2,
    title: 'Majestic Ganesha Festival Idol',
    category: 'Traditional Idols',
    resolution: '4K Ultra HD',
    author: 'Parag Hatim',
    url: 'https://res.cloudinary.com/xklydtk0/image/upload/v1785592758/Parag_Hatim_0235_egoo0z.jpg',
    downloads: '14.2k',
    likes: '3.8k',
    featured: true
  },
  {
    id: 3,
    title: 'Divine Blessings & Shringar',
    category: 'Festival Specials',
    resolution: '4K Ultra HD',
    author: 'Gaurav Kambli',
    url: 'https://res.cloudinary.com/vcwqbraw/image/upload/v1785955640/Gaurav_Kambli_0014_h1ldwx.jpg',
    downloads: '21.5k',
    likes: '5.2k',
    featured: true
  },
  {
    id: 4,
    title: 'Royal Ganpati Bappa Moorti',
    category: 'Traditional Idols',
    resolution: '4K Ultra HD',
    author: 'Parag Hatim',
    url: 'https://res.cloudinary.com/xklydtk0/image/upload/v1785592758/Parag_Hatim_0096_qwtnm0.jpg',
    downloads: '16.9k',
    likes: '4.1k',
    featured: true
  }
];

const CATEGORIES = ['All Wallpapers', 'Lalbaugcha Raja', 'Traditional Idols', 'Festival Specials'];

const FEATURES = [
  {
    icon: '✨',
    title: 'Ultra HD 4K Quality',
    description: 'Crisp, hand-curated high-resolution wallpapers optimized for every screen size.'
  },
  {
    icon: '🔄',
    title: 'Daily Fresh Additions',
    description: 'New divine wallpapers added daily, especially during Ganesh Utsav celebrations.'
  },
  {
    icon: '⚡',
    title: 'One-Tap Wallpaper Set',
    description: 'Set your favourite wallpaper as Home Screen or Lock Screen effortlessly in one click.'
  },
  {
    icon: '🔋',
    title: 'Battery & Storage Efficient',
    description: 'Lightweight app architecture with minimal storage footprint and AMOLED dark modes.'
  },
  {
    icon: '❤️',
    title: 'Favorites & Offline Access',
    description: 'Save your top wallpapers to access them instantly anytime, even without an internet connection.'
  },
  {
    icon: '🛡️',
    title: '100% Free & Secure',
    description: 'Completely free to use with full privacy protection for all devotees and users.'
  }
];

const TESTIMONIALS = [
  {
    name: 'Rahul Deshmukh',
    role: 'Mumbai',
    comment: 'The quality of Lalbaugcha Raja wallpapers is unmatched! Best app for Ganesh Utsav.',
    rating: '5.0 ★'
  },
  {
    name: 'Priya Sharma',
    role: 'Pune',
    comment: 'Instant 4K downloads and smooth interface. Bappa looks divine on my phone screen.',
    rating: '5.0 ★'
  },
  {
    name: 'Amit Patel',
    role: 'Ahmedabad',
    comment: 'Daily updates and easy one-tap set feature make this my favourite wallpaper app!',
    rating: '5.0 ★'
  }
];

const HomePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All Wallpapers');
  const [activeModalWallpaper, setActiveModalWallpaper] = useState(null);
  const [likedItems, setLikedItems] = useState({});

  const filteredWallpapers = selectedCategory === 'All Wallpapers'
    ? WALLPAPERS_DATA
    : WALLPAPERS_DATA.filter(item => item.category === selectedCategory);

  const toggleLike = (id, e) => {
    e.stopPropagation();
    setLikedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleDownload = (wallpaper, e) => {
    if (e) e.stopPropagation();
    window.open(wallpaper.url, '_blank');
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-sparkle">🕉️</span>
            <span>#1 Divine Ganpati Wallpaper App</span>
          </div>
          <h1 className="hero-title">
            Transform Your Screen with <br />
            <span className="hero-highlight">Divine HD & 4K Wallpapers</span>
          </h1>
          <p className="hero-subtitle">
            Immerse yourself in spiritual aura with high-resolution Lalbaugcha Raja, traditional idols, and festive Ganesha artwork for your mobile & desktop.
          </p>

          <div className="hero-actions">
            <a
              href={ANDROID_APP_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              🤖 Download Android App
            </a>
            <a href="#gallery" className="btn-secondary">
              🔍 Explore 4K Gallery
            </a>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-value">50,000+</span>
              <span className="stat-label">Active Devotees</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-value">4.9 ★</span>
              <span className="stat-label">User Rating</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-value">1,000+</span>
              <span className="stat-label">Ultra HD Wallpapers</span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Banner */}
      <section className="featured-strip">
        <div className="strip-container">
          <div className="strip-item">🌟 4K Ultra High Definition</div>
          <div className="strip-item">🌺 Official Photographers Collection</div>
          <div className="strip-item">⚡ One-Tap Screen Setup</div>
          <div className="strip-item">🙏 100% Free Forever</div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery-section">
        <div className="section-header">
          <span className="section-tag">POPULAR COLLECTION</span>
          <h2 className="section-title">Trending Divine Wallpapers</h2>
          <p className="section-description">
            Click on any wallpaper to preview in full screen, download in original 4K resolution, or share with family and friends.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="category-tabs">
          {CATEGORIES.map(category => (
            <button
              key={category}
              className={`category-tab ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Wallpaper Grid */}
        <div className="wallpaper-grid">
          {filteredWallpapers.map(wallpaper => (
            <div
              key={wallpaper.id}
              className="wallpaper-card"
              onClick={() => setActiveModalWallpaper(wallpaper)}
            >
              <div className="card-image-wrapper">
                <img
                  src={wallpaper.url}
                  alt={wallpaper.title}
                  className="wallpaper-img"
                  loading="lazy"
                />
                <div className="card-badge">{wallpaper.resolution}</div>
                <button
                  className={`like-btn ${likedItems[wallpaper.id] ? 'liked' : ''}`}
                  onClick={(e) => toggleLike(wallpaper.id, e)}
                  title="Save to Favorites"
                >
                  {likedItems[wallpaper.id] ? '❤️' : '🤍'}
                </button>
                <div className="card-overlay">
                  <span className="preview-label">👁️ Preview Fullscreen</span>
                </div>
              </div>

              <div className="card-info">
                <div className="card-meta">
                  <span className="meta-category">{wallpaper.category}</span>
                  <span className="meta-author">📸 {wallpaper.author}</span>
                </div>
                <h3 className="card-title">{wallpaper.title}</h3>
                <div className="card-footer">
                  <span className="meta-stats">📥 {wallpaper.downloads} downloads</span>
                  <button
                    className="download-btn-sm"
                    onClick={(e) => handleDownload(wallpaper, e)}
                  >
                    Download HD
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* App Features Section */}
      <section className="features-section">
        <div className="section-header">
          <span className="section-tag">WHY DEVOTEES LOVE US</span>
          <h2 className="section-title">Designed for Spiritual Delight</h2>
          <p className="section-description">
            Experience the best Lord Ganesha wallpaper app with unmatched clarity and seamless user experience.
          </p>
        </div>

        <div className="features-grid">
          {FEATURES.map((feature, idx) => (
            <div key={idx} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* App Download Banner / CTA */}
      <section className="download-banner">
        <div className="banner-content">
          <div className="banner-text">
            <h2>Get Ganpati Wallpaper HD App on Your Mobile</h2>
            <p>
              Download our Android application directly from Google Play Store for daily new wallpapers, live festival feeds, and one-tap lock screen setup.
            </p>
            <div className="banner-buttons">
              <a
                href={ANDROID_APP_URL}
                target="_blank"
                rel="noreferrer"
                className="store-btn primary"
              >
                🤖 Download Android App (Google Play)
              </a>
              <Link to="/support" className="store-btn secondary">
                💬 Need Support? Contact Us
              </Link>
            </div>
          </div>

          <div className="banner-preview">
            <div className="phone-mockup">
              <img
                src={WALLPAPERS_DATA[0].url}
                alt="Ganpati Wallpaper Mobile Preview"
                className="mockup-img"
              />
              <div className="mockup-glare"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-header">
          <span className="section-tag">DEVOTEE REVIEWS</span>
          <h2 className="section-title">Loved by Thousands of Users</h2>
        </div>

        <div className="testimonials-grid">
          {TESTIMONIALS.map((review, idx) => (
            <div key={idx} className="testimonial-card">
              <div className="review-rating">{review.rating}</div>
              <p className="review-comment">"{review.comment}"</p>
              <div className="review-author">
                <strong>{review.name}</strong>
                <span>{review.role}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox / Modal */}
      {activeModalWallpaper && (
        <div className="modal-backdrop" onClick={() => setActiveModalWallpaper(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setActiveModalWallpaper(null)}>
              ✕
            </button>
            <div className="modal-body">
              <div className="modal-image-container">
                <img
                  src={activeModalWallpaper.url}
                  alt={activeModalWallpaper.title}
                  className="modal-img"
                />
              </div>
              <div className="modal-details">
                <span className="modal-badge">{activeModalWallpaper.resolution}</span>
                <h2>{activeModalWallpaper.title}</h2>
                <p className="modal-author">Photographer: <strong>{activeModalWallpaper.author}</strong></p>
                <p className="modal-category">Category: <strong>{activeModalWallpaper.category}</strong></p>

                <div className="modal-actions">
                  <button
                    className="modal-download-btn"
                    onClick={(e) => handleDownload(activeModalWallpaper, e)}
                  >
                    ⬇️ Download High-Res 4K Wallpaper
                  </button>
                  <a
                    href={ANDROID_APP_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="modal-android-btn"
                  >
                    🤖 Set on Phone via Android App
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="home-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <h3>🕉️ Ganpati Wallpaper HD App</h3>
            <p>
              Bringing divine blessings and high-definition Lord Ganesha wallpapers to smartphones worldwide.
            </p>
          </div>

          <div className="footer-links-group">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/support">Support & Contact</Link></li>
              <li>
                <a href={ANDROID_APP_URL} target="_blank" rel="noreferrer" style={{ color: '#ff9933', fontWeight: 'bold' }}>
                  Android App on Play Store ↗
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Support & Contact</h4>
            <p>Email: surajramayadav@gmail.com</p>
            <p>Location: Maharashtra, India</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Ganpati Wallpaper HD App. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
